/*医院*/
const Hospital = r => require.ensure([], () => r(require('./')), 'Hospital')
const HospitalMainPage = r => require.ensure([], () => r(require('./main/')), 'HospitalModule')
const HospitalIndividuationMainPage = r => require.ensure([], () => r(require('./individuation-main/')), 'HospitalIndividuationModule')
/* 医院列表页 */
// const HospitalList = r => require.ensure([], () => r(require('./list/')), 'HospitalList')
/* 医院列表页 （改版逻辑重构）*/
const HospitalListRevised = r => require.ensure([], () => r(require('./list-revised/')), 'HospitalList')
/* 医院详情页 */
// const HospitalDetail = r => require.ensure([], () => r(require('./detail/')), 'HospitalDetail')
/* 医院详情页(改版) */
const HospitalDetailRevised = r => require.ensure([], () => r(require('./detail-revised/')), 'HospitalDetail')
// 秒懂医院
const Video = r => require.ensure([], () => r(require('@/views/hospital/video/'), 'HospitalDetail'))
/* 可预约日期 */
const DateList = r => require.ensure([], () => r(require('./date-list/')), 'HospitalDetail')
/* 医院地图 */
const HospitalMap = r => require.ensure([], () => r(require('./map/')), 'HospitalMap')
/* 医院套餐列表*/
const MealList = r => require.ensure([], () => r(require('./meal/list/')), 'MealList')
/* 医院的套餐详情列表*/
const MealDetail = r => require.ensure([], () => r(require('./meal/detail/')), 'MealDetail')
/* 套餐体检项详情 */
const ItemDetail = r => require.ensure([], () => r(require('@/views/hospital/meal/item-detail/')), 'ItemDetail')
/* 添加加项包 */
const AddItem = r => require.ensure([], () => r(require('@/views/hospital/meal/add-item/')), 'AddItem')

// 选择体检日期
const DateChoose = r => require.ensure([], () => r(require('./dateChoose'), 'HospitalModule'))
//套餐推荐
const RecommendPackage = r => require.ensure([], () => r(require('@/views/hospital/meal/recommend-package/'), 'RecommendPackage'))
//套餐推荐结果
const RecommendResult = r => require.ensure([], () => r(require('@/views/hospital/meal/recommend-result/'), 'RecommendResult'))

export default {
  path:'/hospital',
  component: Hospital,
  meta: { title: '公立医院' },
  redirect: '/hospital/list',
  children: [{
    path: ':hid/main',
    name: 'HospitalMainPage',
    meta: { title: '首页' },
    component: HospitalMainPage
  },
  //上海光华医院首页个性化
  {
    path: ':hid/individuationMain',
    name: 'HospitalIndividuationMainPage',
    meta: { title: '首页' },
    component: HospitalIndividuationMainPage
  },
  // {
  //   path: 'list',
  //   name: 'HospitalList',
  //   meta: { title: '公立医院' },
  //   component: HospitalList
  // },
  // 3.8.5 改版
  {
    path: 'list',
    name: 'HospitalListRevised',
    meta: { title: '公立医院' },
    component: HospitalListRevised
  },
  {
    path: ':hid/meal/:mid/date-choose',
    name: 'date-choose',
    meta: { title: '体检日期' },
    component: DateChoose
  },
  // {
  //   path: ':hid/detail/',
  //   name: 'HospitalDetail',
  //   meta: { title: '医院详情' },
  //   component: HospitalDetail
  // },
  // 3.8.5 改版
  {
    path: ':hid/detail/',
    name: 'HospitalDetailRevised',
    meta: { title: '医院详情' },
    component: HospitalDetailRevised
  },
  {
    path: ':hid/video/',
    name: 'Video',
    meta: { title: '秒懂体检中心' },
    component: Video
  },
  {
    path: ':hid/date-list/',
    name: 'DateList',
    meta: { title: '可预约日期' },
    component: DateList
  },
  {
    path: 'map',
    name: 'HospitalMap',
    meta: { title: '医院地图' },
    component: HospitalMap
  },
  {
    path:':hid/meal/',
    meta:{ title: '医院的套餐列表' },
    component:MealList
  },{
    path:':hid/meal/:pid/detail',
    name: 'meal-detail',
    meta:{ title: '套餐详情' },
    component:MealDetail
  },{
    path:':hid/meal/:pid/item-detail/:fromOps',
    name: 'item-detail',
    meta:{ title: '体检项目' },
    component:ItemDetail
  },{
    path:':hid/meal/:pid/add-item/',
    name: 'add-item',
    meta:{ title: '加项详情' },
    component:AddItem
  },{
    path:'recommend-package',
    name:'recommend',
    meta:{title:'套餐推荐'},
    component:RecommendPackage
  },{
    path:'recommend-result',
    name:'recommend-result',
    meta:{title:'推荐结果'},
    component:RecommendResult
  }]
}



// WEBPACK FOOTER //
// ./src/views/hospital/router.js